import './App.css';
import Task from './Input.js'
import { useState } from 'react'

function Add({item, setItem}) {
     const [value, setValue] = useState("")
     const handleInput = (e) => {
       setValue(e.target.value)
     }
     
     const addTask = () => {
       setItem([...item, {id: 1, name: value, time: new Date().toLocaleTimeString()}])
       setValue("")
     }
  return (
    
    <div className="input">
       <input
       value={value}
       type = "text"
       onChange={handleInput}
       className="put"
       placeholder="type here..."
       />
       <button
       onClick={addTask}
       className="inputButton"
       >Add Task</button>
    </div>
    
  );
}

export default Add;